<template>
  <div class="card mb-3">
    <div class="card-header">
      <i class="fa fa-briefcase"></i>
      {{ $t('event.title') }}
      <createButton name="events_create" :title="$t('event.create.title')"></createButton>
    </div>
    <div class="card-body">
      <errorMessage v-bind:message="error"></errorMessage>

      <div class="table-responsive">
        <table
          class="table table-bordered table-striped"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th class="export">{{ $t('event.form.id') }}</th>
              <th>{{ $t('event.form.name') }}</th>
              <th class="drop-down-filter">{{ $t('event.form.type') }}</th>
               <th class="drop-down-filter">Catégorie</th>
              <th class="drop-down-filter">{{ $t('event.form.detailType') }}</th>
              <th class="date-range-filter">{{ $t('event.form.date') }}</th>
               <th class="date-range-filter">Date de fin</th>
              <th class="export">{{ $t('event.form.organizerType') }}</th>
              <th class="export">{{ $t('event.form.organizer') }}</th>
              <th class="export">{{ $t('event.form.participantCount') }}</th>
              <th class="export">{{ $t('event.form.region') }}</th>
              <th class="export">{{ $t('event.form.place') }}</th>
              <th class="export">{{ $t('event.form.natureOfOrganization') }}</th>
              <th class="export">{{ $t('event.form.businessLevel') }}</th>
              <th class="export">{{ $t('event.form.sectorOfActivity') }}</th>
              <th class="export">{{ $t('event.form.comments') }}</th>
              <th class="no-sort not-export no-filter" v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th class="export">{{ $t('event.form.id') }}</th>
              <th>{{ $t('event.form.name') }}</th>
              <th class="drop-down-filter">{{ $t('event.form.type') }}</th>
                 <th class="drop-down-filter">Catégorie</th>
              <th class="drop-down-filter">{{ $t('event.form.detailType') }}</th>
              <th class="date-range-filter">{{ $t('event.form.date') }}</th>
                <th class="date-range-filter">Date de fin</th>
              <th class="export">{{ $t('event.form.organizerType') }}</th>
              <th class="export">{{ $t('event.form.organizer') }}</th>
              <th class="export">{{ $t('event.form.participantCount') }}</th>
              <th class="export">{{ $t('event.form.region') }}</th>
              <th class="export">{{ $t('event.form.place') }}</th>
              <th class="export">{{ $t('event.form.natureOfOrganization') }}</th>
              <th class="export">{{ $t('event.form.businessLevel') }}</th>
              <th class="export">{{ $t('event.form.sectorOfActivity') }}</th>
              <th class="export">{{ $t('event.form.comments') }}</th>
              <th class="no-sort not-export no-filter" v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </tfoot>
          <tbody>
            <tr
              v-for="event in entites"
              :key="event.id"
              v-bind:data-id="event.id"
              @click="view(event.id)"
              class="clickable-row"
            >
              <td>{{ event.id }}</td>
              <td>{{ event.name != null ? event.name : event.title.french }}</td>
              <td>{{ event.typeText }} {{ event.meetingLocation != null ? '(' + event.meetingLocationText + ')' : '' }}</td>
              <td>{{ event.category }}</td>
              <td>{{ event.detailTypeText }}</td>
              <td>{{ event.startDateAndTime != null ? event.startDateAndTime : event.date | formatDate }}</td>
               <td>{{ event.endDateAndTime | formatDate }}</td>

              <td>{{ event.partnerOrganizer != null ? event.partnerOrganizer.name : (event.memberOrganizer != null ? event.memberOrganizer.familyName + ', ' + event.memberOrganizer.name : ( event.userOrganizer != null ? event.userOrganizer.fullName : '' )) }}</td>
              <td>{{ event.partnerOrganizerId != null ? 'Partner' : (event.memberOrganizerId != null ? 'Membre' : (event.userOrganizerId != null ? 'Utilisateur' : '')) }}</td>

              <td>{{ event.participantCount }}</td>
              <td>{{ event.regionText }}</td>
              <td>{{ event.place }}</td>

              <td>{{ event.natureOfOrganizationText }}</td>
              <td>{{ event.businessLevelText }}</td>
              <td>{{ event.sectorOfActivityText }}</td>

              <td>{{ event.comments }}</td>

              <td class="no-sort" align="center" v-if="canCreate || canDelete">
                <a
                  href="#"
                  v-if="canCreate"
                  v-bind:title="$t('form.edit_button')"
                  v-on:click.stop="edit(event.id)"
                >
                  <span class="fa fa-lg fa-pencil"></span>
                </a>
                &nbsp;
                <a
                  href="#"
                  v-if="canCreate"
                  v-bind:title="$t('form.copy_button')"
                  v-on:click.stop="copy(event.id)"
                >
                  <span class="fa fa-lg fa-copy"></span>
                </a>
                &nbsp;
                <a
                  class="text-danger"
                  v-if="canDelete"
                  v-bind:title="$t('form.delete_button')"
                  href="#"
                  v-on:click.stop="deleteEntity(event.id)"
                >
                  <span class="fa fa-lg fa-trash"></span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {EventServiceClient} from '../../shared/service-clients/service-clients'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'

export default {
  name: 'events',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: EventServiceClient,
    }
  },
  methods: {
    displayDate: function(event) {
      var date = ''
      if (event.startDateAndTime != null) {
        date += moment(String(event.startDateAndTime))
          .format('DD/MM/YYYY')
          .toString()
        console.log(date)
      } else {
        date += moment(String(event.date))
          .format('DD/MM/YYYY')
          .toString()
      }
      if (event.startTime != null) {
        date += ' ' + event.startTime
        console.log(date)
      }

      if (event.endDateAndTime != null) {
        date +=
          ' - ' +
          moment(String(event.endDateAndTime))
            .format('DD/MM/YYYY')
            .toString()
        console.log(date)
      }

      if (event.endTime != null) {
        date += ' ' + event.endTime
      }
      return date
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/events/Events.vue